export default "__VITE_ASSET__2ekSAh$x__"